<template>
    <div class="flex items-center justify-center w-full bg-blue-200 text-blue-700 text-center leading-tight py-3 px-3 sm:text-md">
        <div>
            <span class="font-bold">Welcome!</span> Your free trial expires in {{ expires_in_days }} day{{ expires_in_days > 1 ? 's' : ''}}.
        </div>

        <a v-if="! on_payment_route"
            :href="payment_route || '/broker/settings/billing'"
        >
            <button-blue type="button" class="ml-6" size="small">
                {{ is_monthly || is_yearly ? 'Subscribe Now' : 'Pay Now' }}
            </button-blue>
        </a>
    </div>
</template>

<script>
import ButtonBlue from '../components/button-blue.vue';

export default {
    components: {
        ButtonBlue,
    },

    props: {
        expires_in_days: {},
        payment_route: {},
        on_payment_route: { default: false },
        is_monthly: { default: true },
        is_yearly: { default: false },
    },
}
</script>
